/* GET LEADS */
export const GET_PROSPECTS = "GET_PROSPECTS" // "GET_LEADS" 
export const GET_PROSPECTS_SUCCESS = "GET_PROSPECTS_SUCCESS" // "GET_LEADS_SUCCESS" 
export const GET_PROSPECTS_ERROR = "GET_PROSPECTS_ERROR" // "GET_LEADS_ERROR" 

export const UPDATE_PROSPECT = "UPDATE_PROSPECT" // "UPDATE_LEAD" 
export const UPDATE_PROSPECT_SUCCESS = "UPDATE_PROSPECT_SUCCESS" // "UPDATE_LEAD_SUCCESS" 
export const UPDATE_PROSPECT_ERROR = "UPDATE_PROSPECT_ERROR" // "UPDATE_LEAD_ERROR" 

export const GET_PROSPECT_BY_ID = "GET_PROSPECT_BY_ID" // "GET_LEAD_BY_ID" 
export const GET_PROSPECT_BY_ID_SUCCESS = "GET_PROSPECT_BY_ID_SUCCESS" // "GET_LEAD_BY_ID_SUCCESS" 
export const GET_PROSPECT_BY_ID_ERROR = "GET_PROSPECT_BY_ID_ERROR" // "GET_LEAD_BY_ID_ERROR" 

export const UPDATE_PROSPECT_DETAILS = "UPDATE_PROSPECT_DETAILS" // "UPDATE_LEAD_DETAILS" 
export const UPDATE_PROSPECT_DETAILS_SUCCESS = "UPDATE_PROSPECT_DETAILS_SUCCESS" // "UPDATE_LEAD_DETAILS_SUCCESS" 
export const UPDATE_PROSPECT_DETAILS_ERROR = "UPDATE_PROSPECT_DETAILS_ERROR" // "UPDATE_LEAD_DETAILS_ERROR" 

export const ADD_PROSPECT_VEHICLE = "ADD_PROSPECT_VEHICLE" // "ADD_LEAD_VEHICLE"
export const ADD_PROSPECT_VEHICLE_SUCCESS = "ADD_PROSPECT_VEHICLE_SUCCESS" // "ADD_LEAD_VEHICLE_SUCCESS"
export const ADD_PROSPECT_VEHICLE_ERROR = "ADD_PROSPECT_VEHICLE_ERROR" // "ADD_LEAD_VEHICLE_ERROR"

export const UPDATE_PROSPECT_VEHICLE = "UPDATE_PROSPECT_VEHICLE" // "UPDATE_LEAD_VEHICLE"
export const UPDATE_PROSPECT_VEHICLE_SUCCESS = "UPDATE_PROSPECT_VEHICLE_SUCCESS" // "UPDATE_LEAD_VEHICLE_SUCCESS"
export const UPDATE_PROSPECT_VEHICLE_ERROR = "UPDATE_PROSPECT_VEHICLE_ERROR" // "UPDATE_LEAD_VEHICLE_ERROR"

export const DELETE_PROSPECT_VEHICLE = "DELETE_PROSPECT_VEHICLE" // "DELETE_LEAD_VEHICLE"
export const DELETE_PROSPECT_VEHICLE_SUCCESS = "DELETE_PROSPECT_VEHICLE_SUCCESS" // "DELETE_LEAD_VEHICLE_SUCCESS"
export const DELETE_PROSPECT_VEHICLE_ERROR = "DELETE_PROSPECT_VEHICLE_ERROR" // "DELETE_LEAD_VEHICLE_ERROR"

export const ADD_PROSPECT_HOME = "ADD_PROSPECT_HOME" // "ADD_LEAD_HOME"
export const ADD_PROSPECT_HOME_SUCCESS = "ADD_PROSPECT_HOME_SUCCESS" // "ADD_LEAD_HOME_SUCCESS"
export const ADD_PROSPECT_HOME_ERROR = "ADD_PROSPECT_HOME_ERROR" // "ADD_LEAD_HOME_ERROR"

export const UPDATE_PROSPECT_HOME = "UPDATE_PROSPECT_HOME" // "UPDATE_LEAD_HOME"
export const UPDATE_PROSPECT_HOME_SUCCESS = "UPDATE_PROSPECT_HOME_SUCCESS" // "UPDATE_LEAD_HOME_SUCCESS"
export const UPDATE_PROSPECT_HOME_ERROR = "UPDATE_PROSPECT_HOME_ERROR" // "UPDATE_LEAD_HOME_ERROR"

export const DELETE_PROSPECT_HOME = "DELETE_PROSPECT_HOME" // "DELETE_LEAD_HOME"
export const DELETE_PROSPECT_HOME_SUCCESS = "DELETE_PROSPECT_HOME_SUCCESS" // "DELETE_LEAD_HOME_SUCCESS"
export const DELETE_PROSPECT_HOME_ERROR = "DELETE_PROSPECT_HOME_ERROR" // "DELETE_LEAD_HOME_ERROR"

export const ADD_PROSPECT_BUSINESS_ENTITY = "ADD_PROSPECT_BUSINESS_ENTITY" // "ADD_LEAD_BUSINESS_ENTITY"
export const ADD_PROSPECT_BUSINESS_ENTITY_SUCCESS = "ADD_PROSPECT_BUSINESS_ENTITY_SUCCESS" // "ADD_LEAD_BUSINESS_ENTITY_SUCCESS"
export const ADD_PROSPECT_BUSINESS_ENTITY_ERROR = "ADD_PROSPECT_BUSINESS_ENTITY_ERROR" // "ADD_LEAD_BUSINESS_ENTITY_ERROR"

export const UPDATE_PROSPECT_BUSINESS_ENTITY = "UPDATE_PROSPECT_BUSINESS_ENTITY" // "UPDATE_LEAD_BUSINESS_ENTITY"
export const UPDATE_PROSPECT_BUSINESS_ENTITY_SUCCESS = "UPDATE_PROSPECT_BUSINESS_ENTITY_SUCCESS" // "UPDATE_LEAD_BUSINESS_ENTITY_SUCCESS"
export const UPDATE_PROSPECT_BUSINESS_ENTITY_ERROR = "UPDATE_PROSPECT_BUSINESS_ENTITY_ERROR" // "UPDATE_LEAD_BUSINESS_ENTITY_ERROR"

export const DELETE_PROSPECT_BUSINESS_ENTITY = "DELETE_PROSPECT_BUSINESS_ENTITY" // "DELETE_LEAD_BUSINESS_ENTITY"
export const DELETE_PROSPECT_BUSINESS_ENTITY_SUCCESS = "DELETE_PROSPECT_BUSINESS_ENTITY_SUCCESS" // "DELETE_LEAD_BUSINESS_ENTITY_SUCCESS"
export const DELETE_PROSPECT_BUSINESS_ENTITY_ERROR = "DELETE_PROSPECT_BUSINESS_ENTITY_ERROR" // "DELETE_LEAD_BUSINESS_ENTITY_ERROR"

export const ADD_PROSPECT_VIOLATION = "ADD_PROSPECT_VIOLATION" // "ADD_LEAD_VIOLATION"
export const ADD_PROSPECT_VIOLATION_SUCCESS = "ADD_PROSPECT_VIOLATION_SUCCESS" // "ADD_LEAD_VIOLATION_SUCCESS"
export const ADD_PROSPECT_VIOLATION_ERROR = "ADD_PROSPECT_VIOLATION_ERROR" // "ADD_LEAD_VIOLATION_ERROR"

export const UPDATE_PROSPECT_VIOLATION = "UPDATE_PROSPECT_VIOLATION" // "UPDATE_LEAD_VIOLATION"
export const UPDATE_PROSPECT_VIOLATION_SUCCESS = "UPDATE_PROSPECT_VIOLATION_SUCCESS" // "UPDATE_LEAD_VIOLATION_SUCCESS"
export const UPDATE_PROSPECT_VIOLATION_ERROR = "UPDATE_PROSPECT_VIOLATION_ERROR" // "UPDATE_LEAD_VIOLATION_ERROR"

export const DELETE_PROSPECT_VIOLATION = "DELETE_PROSPECT_VIOLATION" // "DELETE_LEAD_VIOLATION"
export const DELETE_PROSPECT_VIOLATION_SUCCESS = "DELETE_PROSPECT_VIOLATION_SUCCESS" // "DELETE_LEAD_VIOLATION_SUCCESS"
export const DELETE_PROSPECT_VIOLATION_ERROR = "DELETE_PROSPECT_VIOLATION_ERROR" // "DELETE_LEAD_VIOLATION_ERROR"

export const ADD_PROSPECT_REFUND = "ADD_PROSPECT_REFUND" // "ADD_LEAD_REFUND"
export const ADD_PROSPECT_REFUND_SUCCESS = "ADD_PROSPECT_REFUND_SUCCESS" // "ADD_LEAD_REFUND_SUCCESS"
export const ADD_PROSPECT_REFUND_ERROR = "ADD_PROSPECT_REFUND_ERROR" // "ADD_LEAD_REFUND_ERROR"

export const UPDATE_PROSPECT_REFUND = "UPDATE_PROSPECT_REFUND" // "UPDATE_LEAD_REFUND"
export const UPDATE_PROSPECT_REFUND_SUCCESS = "UPDATE_PROSPECT_REFUND_SUCCESS" // "UPDATE_LEAD_REFUND_SUCCESS"
export const UPDATE_PROSPECT_REFUND_ERROR = "UPDATE_PROSPECT_REFUND_ERROR" // "UPDATE_LEAD_REFUND_ERROR"

export const DELETE_PROSPECT_REFUND = "DELETE_PROSPECT_REFUND" // "DELETE_LEAD_REFUND"
export const DELETE_PROSPECT_REFUND_SUCCESS = "DELETE_PROSPECT_REFUND_SUCCESS" // "DELETE_LEAD_REFUND_SUCCESS"
export const DELETE_PROSPECT_REFUND_ERROR = "DELETE_PROSPECT_REFUND_ERROR" // "DELETE_LEAD_REFUND_ERROR"

export const ADD_PROSPECT_APPLICANT = "ADD_PROSPECT_APPLICANT" // "ADD_LEAD_APPLICANT"
export const ADD_PROSPECT_APPLICANT_SUCCESS = "ADD_PROSPECT_APPLICANT_SUCCESS" // "ADD_LEAD_APPLICANT_SUCCESS"
export const ADD_PROSPECT_APPLICANT_ERROR = "ADD_PROSPECT_APPLICANT_ERROR" // "ADD_LEAD_APPLICANT_ERROR"

export const UPDATE_PROSPECT_APPLICANT = "UPDATE_PROSPECT_APPLICANT" // "UPDATE_LEAD_APPLICANT"
export const UPDATE_PROSPECT_APPLICANT_SUCCESS = "UPDATE_PROSPECT_APPLICANT_SUCCESS" // "UPDATE_LEAD_APPLICANT_SUCCESS"
export const UPDATE_PROSPECT_APPLICANT_ERROR = "UPDATE_PROSPECT_APPLICANT_ERROR" // "UPDATE_LEAD_APPLICANT_ERROR"

export const DELETE_PROSPECT_APPLICANT = "DELETE_PROSPECT_APPLICANT" // "DELETE_LEAD_APPLICANT"
export const DELETE_PROSPECT_APPLICANT_SUCCESS = "DELETE_PROSPECT_APPLICANT_SUCCESS" // "DELETE_LEAD_APPLICANT_SUCCESS"
export const DELETE_PROSPECT_APPLICANT_ERROR = "DELETE_PROSPECT_APPLICANT_ERROR" // "DELETE_LEAD_APPLICANT_ERROR"

export const GET_PROSPECT_REFUND_REASONS = "GET_PROSPECT_REFUND_REASONS" // "GET_LEAD_REFUND_REASONS"
export const GET_PROSPECT_REFUND_REASONS_SUCCESS = "GET_PROSPECT_REFUND_REASONS_SUCCESS" // "GET_LEAD_REFUND_REASONS_SUCCESS"
export const GET_PROSPECT_REFUND_REASONS_ERROR = "GET_PROSPECT_REFUND_REASONS_ERROR" // "GET_LEAD_REFUND_REASONS_ERROR"

export const GET_CONSENT_INFORMATION_BY_ID = 'GET_CONSENT_INFORMATION_BY_ID'
export const GET_CONSENT_INFORMATION_BY_ID_SUCCESS = 'GET_CONSENT_INFORMATION_BY_ID_SUCCESS'
export const GET_CONSENT_INFORMATION_BY_ID_ERROR = 'GET_CONSENT_INFORMATION_BY_ID_ERROR'

export const GET_PROSPECT_DETAILS_EXPORT = "GET_PROSPECT_DETAILS_EXPORT"
export const GET_PROSPECT_DETAILS_EXPORT_SUCCESS = "GET_PROSPECT_DETAILS_EXPORT_SUCCESS"
export const GET_PROSPECT_DETAILS_EXPORT_ERROR = "GET_PROSPECT_DETAILS_EXPORT_ERROR"